import React from 'react'
import { MenuItems } from './menuitems'
import './navbar.css';
import { useState  } from 'react';
import { Link } from 'react-router-dom';


function NavBar() {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(!clicked); // Toggle the `clicked` state
  };
  return (
    <>
     <nav className='navbar-items'>
        <h1 className='navbar-logo'>
            TRIPPY
        </h1>
        <div className='menu-icons' onClick={handleClick} >
          <i className={clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
        <ul className={clicked? 'nav-menu active' : 'nav-menu'}>
            {MenuItems.map((item,index)=>{
                return  <li key={index}>
                <Link className={item.cName} to={item.url}>
                <i className={item.icon}></i>{item.title}
                </Link>
            </li>
            })} 
            <button>Signup</button>
        </ul>
     </nav>
    </>
  )
}

export default NavBar